import _extends from '@babel/runtime/helpers/esm/extends';
import React from 'react';
import { PropTypes, describe } from 'react-desc';
import { ToastContainer, Slide } from 'react-toastify';
import CloseSmall from '@elliemae/ds-icons/CloseSmall';
import DSButton from '@elliemae/ds-button';
import { toastsPositions } from './ToastPosition.js';

var CloseButton = function CloseButton(_ref) {
  var closeToast = _ref.closeToast;
  return /*#__PURE__*/React.createElement(DSButton, {
    buttonType: "text",
    className: "toast-close-button",
    icon: /*#__PURE__*/React.createElement(CloseSmall, null),
    onClick: closeToast,
    size: "m"
  });
};

var DSToast = function DSToast(_ref2) {
  var _ref2$containerProps = _ref2.containerProps,
      containerProps = _ref2$containerProps === void 0 ? {} : _ref2$containerProps,
      _ref2$position = _ref2.position,
      position = _ref2$position === void 0 ? 'bottom-left' : _ref2$position,
      _ref2$autoClose = _ref2.autoClose,
      autoClose = _ref2$autoClose === void 0 ? 5000 : _ref2$autoClose,
      _ref2$showProgressBar = _ref2.showProgressBar,
      showProgressBar = _ref2$showProgressBar === void 0 ? false : _ref2$showProgressBar,
      _ref2$closeOnClick = _ref2.closeOnClick,
      closeOnClick = _ref2$closeOnClick === void 0 ? false : _ref2$closeOnClick,
      _ref2$enableMultiCont = _ref2.enableMultiContainer,
      enableMultiContainer = _ref2$enableMultiCont === void 0 ? false : _ref2$enableMultiCont,
      _ref2$containerId = _ref2.containerId,
      containerId = _ref2$containerId === void 0 ? undefined : _ref2$containerId,
      _ref2$toastId = _ref2.toastId,
      toastId = _ref2$toastId === void 0 ? undefined : _ref2$toastId;
  return /*#__PURE__*/React.createElement(ToastContainer, _extends({}, containerProps, {
    autoClose: autoClose,
    className: showProgressBar && 'with-progressbar' || '',
    closeButton: /*#__PURE__*/React.createElement(CloseButton, null),
    closeOnClick: closeOnClick,
    containerId: containerId,
    enableMultiContainer: enableMultiContainer,
    hideProgressBar: !showProgressBar,
    newestOnTop: true,
    position: position,
    toastId: toastId,
    transition: Slide
  }));
};

var props = {
  /** inject props to wrapper */
  containerProps: PropTypes.object.description('inject props to wrapper'),

  /** Position on the screen to show the toast */
  position: PropTypes.oneOf(toastsPositions).description('Position on the screen to show the toast'),

  /** ms to autoclose the toast */
  autoClose: PropTypes.number.description('ms to autoclose the toast'),

  /** Whether to show a progress bar indicating when the toast is going to be closed */
  showProgressBar: PropTypes.bool.description('Whether to show a progress bar indicating when the toast is going to be closed'),

  /** Close toast handler */
  closeOnClick: PropTypes.bool.description('Close toast handler'),

  /** Allows instantiating multiple Toast containers */
  enableMultiContainer: PropTypes.bool.description('Allows instantiating multiple Toast containers'),

  /** unique id for multi container */
  containerId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('unique id for multi container'),

  /**  id for the toast */
  toastId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).description('id for the toast')
};
DSToast.propTypes = props;
var DSToastWithSchema = describe(DSToast);
DSToastWithSchema.propTypes = props;

export default DSToast;
export { DSToast, DSToastWithSchema };
//# sourceMappingURL=DSToast.js.map
